module.exports = __webpack_public_path__ + "static/media/get-recommendations-mobile-es.21f2eb5f.png";